import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { BaseComponent } from '@wms/components';

@Component({
  selector: 'wms-wizard',
  standalone: true,
  templateUrl: './wms-wizard.component.html',
  styleUrls: ['./wms-wizard.component.less'],
  imports: [
    CommonModule
  ]
})
export class WmsWizardComponent extends BaseComponent implements OnInit {

  @Input() steps!: Array<any>;
  @Input() counter!: any;
  @Input() height!: any;
  @Input() show: boolean = true;
  @Input() innerSteps: any;
  isNativeMobileApplicationType: boolean;
  
  constructor() { 
    super();
    this.isNativeMobileApplicationType = this.projectService.isNativeMobileApplicationType();

  }

  ngOnInit(): void {
  }

}
